
import { computed } from '@vue/composition-api';
import { Button } from '05-ui-kit';
import { declination } from '@artmizu/utils';
import TSProductRating from '~/components/ts-components/TSProductRating/TSProductRating.vue';
import type { ReviewRating } from '~/type/Review';
const __sfc_main = {};
__sfc_main.props = {
  link: {
    key: "link",
    required: false,
    type: String,
    default: '#'
  },
  data: {
    key: "data",
    required: true,
    type: null
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const convertRateText = computed(() => {
    return props.data.reviewCount ? `${props.data.reviewCount} ${declination(props.data.reviewCount, ['отзыв', 'отзыва', 'отзывов'])}` : null;
  });
  const list = computed(() => {
    const score = props.data.list;
    return [{
      score: '5 звезд',
      width: score.five / props.data.count * 100,
      count: score.five
    }, {
      score: '4 звезды',
      width: score.four / props.data.count * 100,
      count: score.four
    }, {
      score: '3 звезды',
      width: score.three / props.data.count * 100,
      count: score.three
    }, {
      score: '2 звезды',
      width: score.two / props.data.count * 100,
      count: score.two
    }, {
      score: '1 звезда',
      width: score.one / props.data.count * 100,
      count: score.one
    }];
  });
  return {
    convertRateText,
    list
  };
};
__sfc_main.components = Object.assign({
  TSProductRating,
  Button
}, __sfc_main.components);
export default __sfc_main;
